// extracted by mini-css-extract-plugin
export default {"btn":"Paginate_btn__SC9nq","count":"Paginate_count__NYB0d","paginate":"Paginate_paginate__Ewe7Z"};